type SendMessageToUnreal = (message: unknown) => void;

export type HotspotPlacementVariant = '2D' | '3D';

export interface HotspotPlacementPayload {
  brandingHotspotId?: string;
  name?: string;
  roomId?: string;
  type?: string;
  data?: {
    url?: string;
    webBrowserUrl?: string;
    [key: string]: unknown;
  };
}

/**
 * Asks UE to start in-world placement of a hotspot.
 *
 * The id is sent twice on purpose: UE's hotspot parser reads it only from
 * `mapSpotId` (or `roomSpotId`), so without the alias it cannot echo the id
 * back in `FINISH_HOTSPOT_PLACE_*` and the hub would have to fall back to
 * "the single active placement session" for correlation.
 *
 * @param sendMessageToUnreal - Bridge that forwards the message to the stream.
 * @param variant - Which placement flow UE should run ('2D' or '3D').
 * @param payload - Hotspot data ridden along and echoed back on finish.
 */
export const startHotspotPlaceInUnreal = (
  sendMessageToUnreal: SendMessageToUnreal,
  variant: HotspotPlacementVariant,
  payload: HotspotPlacementPayload,
) => {
  const { brandingHotspotId } = payload;

  sendMessageToUnreal({
    action:
      variant === '3D' ? 'START_HOTSPOT_PLACE_3D' : 'START_HOTSPOT_PLACE_2D',
    ...payload,
    ...(brandingHotspotId ? { mapSpotId: brandingHotspotId } : {}),
  });
};

/**
 * Nudges UE to re-fetch the authoritative room state after a branding change.
 *
 * @param sendMessageToUnreal - Bridge that forwards the message to the stream.
 */
export const notifyHotspotsUpdatedInUnreal = (
  sendMessageToUnreal: SendMessageToUnreal,
) => {
  sendMessageToUnreal({
    action: 'SPOTS_UPDATED',
    spots: [],
  });
};
